import React, { Component } from 'react';
import { connect } from 'react-redux';

import {startDriving} from '../../state/actions/timeline';

import Annotation from '../Annotation';
import DetailPage from '../DetailPage';

class Popup extends Component {

    render() {
        switch (this.props.story.type) {
            case "story":
                return <DetailPage preview={true} />;
            case "annotation":
                return <Annotation {...this.props.story} />;
            default:
                return null;
        }
    }

}

function mapStateToProps({timeline}) {
    return {
        story: timeline.showStory
    }
}

export default connect(mapStateToProps, {startDriving})(Popup);


// WEBPACK FOOTER //
// ./src/components/Popup/index.js